'use strict';

export default {
  data() {
    return {
      promptText: '',
    };
  },
  methods: {
    async msgBoxConfirm({
      message,
      title,
      okTitle = this.$gt('proceed', { ns: 'general' }),
      cancelTitle = this.$gt('cancel', { ns: 'general' }),
      confirmationHandler,
      cancellationHandler,
      errorHandler,
      GtmLabel,
      GtmValue = null,
      logToConsole = false,
      showPrompt = false,
      showCancel = true,
    }) {
      const defaultDialogOptions = {
        title: title ?? this.$gt('action_confirmation', { ns: 'modals' }),
        message:
          message ??
          this.$gt('please_confirm_you_really_want_to_perform_this_action', { ns: 'modals' }),
        size: 'md',
        persistent: true,
        prompt: showPrompt
          ? {
              model: '',
              type: 'text',
              isValid: (val) => val === this.promptText,
              attrs: {
                autocomplete: 'off',
              },
              filled: true,
            }
          : undefined,
        ok: {
          flat: true,
          color: 'primary',
          label: okTitle,
        },
        cancel: showCancel
          ? {
              flat: true,
              color: 'red-7',
              label: cancelTitle,
            }
          : false,
      };

      return new Promise((resolve, reject) => {
        this.$q
          .dialog(defaultDialogOptions)
          .onOk(async () => {
            this.$gtm.trackEvent({
              event: 'GotedoCustomEvent',
              category: 'Modal Events',
              action: 'Confirm',
              label: GtmLabel,
              value: GtmValue ? GtmValue : '',
              noninteraction: false,
            });

            if (!confirmationHandler) {
              if (confirmationHandler !== null) {
                console.warn('No confirmation handler provided');
              }
              return resolve(true);
            }

            try {
              await confirmationHandler();

              this.$gtm.trackEvent({
                event: 'GotedoCustomEvent',
                category: 'Modal Events',
                action: 'Confirmation Handler Success',
                label: GtmLabel,
                value: null,
                noninteraction: false,
              });

              return resolve(true);
            } catch (error) {
              if (logToConsole) {
                console.error(error); //eslint-disable no-console
              }

              this.$gtm.trackEvent({
                event: 'GotedoCustomEvent',
                category: 'Modal Events',
                action: 'Confirmation Handler Error',
                label: GtmLabel,
                value: error ? JSON.stringify(error) : '',
                noninteraction: false,
              });

              if (errorHandler) {
                errorHandler(error);
                return reject(false);
              }

              return reject(error);
            }
          })
          .onCancel(async () => {
            if (!cancellationHandler) {
              if (cancellationHandler !== null) {
                console.warn('No cancellation handler provided');
              }
              return reject(false);
            }

            try {
              // Use try...catch because `cancellationHandler` is not always
              // a promise
              const response = await cancellationHandler();
              this.$gtm.trackEvent({
                event: 'GotedoCustomEvent',
                category: 'Modal Events',
                action: 'Cancel',
                label: GtmLabel,
                value: GtmValue ? GtmValue : '',
                noninteraction: false,
              });

              return resolve(response);
            } catch (error) {
              if (logToConsole) {
                console.error(error); //eslint-disable no-console
              }

              this.$gtm.trackEvent({
                event: 'GotedoCustomEvent',
                category: 'Modal Events',
                action: 'Cancellation Handler Error',
                label: GtmLabel,
                value: error ? JSON.stringify(error) : '',
                noninteraction: false,
              });

              if (errorHandler) {
                errorHandler(error);
                return reject(error);
              }

              return reject(error);
            }
          });
      });
    },

    async msgBoxOk({
      message,
      title,
      okTitle,
      confirmationHandler,
      cancellationHandler,
      errorHandler,
      GtmLabel,
      GtmValue = null,
      logToConsole = false,
    }) {
      await this.msgBoxConfirm({
        message,
        title,
        okTitle,
        confirmationHandler,
        cancellationHandler,
        GtmLabel,
        errorHandler,
        GtmValue,
        logToConsole,
        showPrompt: false,
        showCancel: false,
      });
    },
  },
};
